import CreateTemplatePopup from "./CreateTemplatePopup";

export default CreateTemplatePopup;



// WEBPACK FOOTER //
// ./src/components/CreateTemplatePopup/index.js